import { useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    project_type: '',
    message: ''
  });
  const [submitStatus, setSubmitStatus] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');

    try {
      await axios.post(`${API}/contact`, formData);
      setSubmitStatus('success');
      setFormData({
        name: '',
        email: '',
        phone: '',
        company: '',
        project_type: '',
        message: ''
      });
    } catch (error) {
      console.error('Error submitting form:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-form-wrapper">
      <form onSubmit={handleSubmit} className="contact-form" data-testid="contact-form">
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="name">Name *</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              required
              data-testid="contact-name-input"
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">E-Mail *</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              required
              data-testid="contact-email-input"
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label htmlFor="phone">Telefon</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleInputChange}
              data-testid="contact-phone-input"
            />
          </div>
          <div className="form-group">
            <label htmlFor="company">Firma</label>
            <input
              type="text"
              id="company"
              name="company"
              value={formData.company}
              onChange={handleInputChange}
              data-testid="contact-company-input"
            />
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="project_type">Projektart</label>
          <select
            id="project_type"
            name="project_type"
            value={formData.project_type}
            onChange={handleInputChange}
            data-testid="contact-project-type-select"
          >
            <option value="">Bitte wählen</option>
            <option value="ai-video">AI-Videoproduktion / KI-Video</option>
            <option value="interview">Interview / Videoportrait</option>
            <option value="commercial">Werbespot / Imagefilm</option>
            <option value="documentary">Dokumentation</option>
            <option value="tv">TV-Produktion</option>
            <option value="event">Event-Dokumentation</option>
            <option value="musikvideo">Musikvideo</option>
            <option value="other">Sonstiges</option>
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="message">Nachricht *</label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleInputChange}
            rows="5"
            required
            data-testid="contact-message-textarea"
          ></textarea>
        </div>

        <button
          type="submit"
          className="submit-button"
          disabled={isSubmitting}
          data-magnetic="true"
          data-testid="contact-submit-button"
        >
          {isSubmitting ? 'Wird gesendet...' : 'Nachricht senden'}
        </button>

        <p className="form-privacy-hint" data-testid="contact-privacy-hint">
          Mit dem Absenden stimmst du der Verarbeitung deiner Angaben zur Bearbeitung der Anfrage zu.
          Details in der <a href="/datenschutz" target="_blank" rel="noopener noreferrer">Datenschutzerklärung</a>.
        </p>

        {submitStatus === 'success' && (
          <div className="form-message success" data-testid="success-message">
            ✓ Vielen Dank! Andreas meldet sich in Kürze bei dir.
          </div>
        )}
        {submitStatus === 'error' && (
          <div className="form-message error" data-testid="error-message">
            ✗ Ein Fehler ist aufgetreten. Bitte versuch es erneut.
          </div>
        )}
      </form>
    </div>
  );
}
